module.exports = __webpack_public_path__ + "img/Background-Magnets-2366x901.e9cae590.jpeg";